import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "swiper/css";
import "swiper/css/pagination";
import { Helmet } from "react-helmet";
import ServiceInclude from "../../component/ServiceInclude";


const CommercialCloud = () => {

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <>

            <Helmet prioritizeSeoTags={true}>
                <meta httpEquiv="content-type" content="text/html; charset=utf-8" />
                <meta name="format-detection" content="telephone=no" />
                <title>Top Salesforce Commerce Cloud Consultant</title>
                <meta name="viewport" content="width=device-width, initial-scale=1" />

                <meta
                    name="description"
                    content="Codezix is a leading Salesforce Commerce Cloud consultant delivering ecommerce strategy, storefront implementation, order management, headless commerce and integration services to scale online sales."
                />
                <meta
                    name="keywords"
                    content="Salesforce Commerce Cloud, Commerce Cloud consultant, ecommerce implementation, storefront development, order management, headless commerce, Commerce Cloud integration"
                />

                {/* BreadcrumbList (Kuwait page) */}
                <script type="application/ld+json">
                    {`
{
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  "itemListElement": [
    {
      "@type": "ListItem",
      "position": 1,
      "name": "Home",
      "item": "https://codezix.com/"
    },
    {
      "@type": "ListItem",
      "position": 2,
      "name": "Salesforce Commerce Cloud",
      "item": "https://www.codezix.com/salesforce/commerce-cloud"
    },
    {
      "@type": "ListItem",
      "position": 3,
      "name": "Salesforce Development Company in Kuwait",
      "item": "https://www.codezix.com/salesforce/development-company-in-kuwait"
    }
  ]
}
        `}
                </script>

                {/* Organization */}
                <script type="application/ld+json">
                    {`
{
  "@context": "https://schema.org",
  "@type": "Organization",
  "@id": "https://codezix.com/#organization",
  "name": "Codezix",
  "legalName": "Codezix Solutions",
  "url": "https://codezix.com/",
  "logo": {
    "@type": "ImageObject",
    "url": "https://codezix.com/assets/images/logo.webp",
    "width": 250,
    "height": 80
  },
  "image": "https://codezix.com/assets/images/logo.webp",
  "description": "Codezix is a global Salesforce consulting and cloud solution provider helping enterprises grow with tailored CRM, commerce and integration strategies.",
  "email": "info@codezix.com",
  "telephone": "+1-917-730-7436",
  "sameAs": [
    "https://www.linkedin.com/company/codezix",
    "https://www.facebook.com/codezix",
    "https://twitter.com/codezix"
  ]
}
        `}
                </script>

                {/* WebSite */}
                <script type="application/ld+json">
                    {`
{
  "@context": "https://schema.org",
  "@type": "WebSite",
  "@id": "https://codezix.com/#website",
  "url": "https://codezix.com/",
  "name": "Codezix",
  "publisher": {
    "@id": "https://codezix.com/#organization"
  }
}
        `}
                </script>

                {/* WebPage (Kuwait page) */}
                <script type="application/ld+json">
                    {`
{
  "@context": "https://schema.org",
  "@type": "WebPage",
  "@id": "https://www.codezix.com/salesforce/development-company-in-kuwait#webpage",
  "url": "https://www.codezix.com/salesforce/development-company-in-kuwait",
  "name": "Top Salesforce Commerce Cloud Consultant",
  "inLanguage": "en-US",
  "description": "Codezix is a leading Salesforce Commerce Cloud consultant delivering ecommerce strategy, storefront implementation, order management, headless commerce and integration services to scale online sales.",
  "isPartOf": {
    "@id": "https://codezix.com/#website"
  }
}
        `}
                </script>

                {/* Service — Kuwait Development Page (separate) */}
                <script type="application/ld+json">
                    {`
{
  "@context": "https://schema.org",
  "@type": "Service",
  "@id": "https://www.codezix.com/salesforce/development-company-in-kuwait#service",
  "url": "https://www.codezix.com/salesforce/development-company-in-kuwait",
  "serviceType": "Salesforce Development Services",
  "name": "Salesforce Development Company in Kuwait",
  "description": "Custom Salesforce development, integrations, commerce connectors and CRM optimization services provided by Codezix for businesses in Kuwait.",
  "provider": {
    "@type": "Organization",
    "@id": "https://codezix.com/#organization"
  },
  "areaServed": {
    "@type": "City",
    "name": "Kuwait"
  },
  "hasOfferCatalog": {
    "@type": "OfferCatalog",
    "name": "Salesforce Development Services",
    "itemListElement": [
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "Custom Apex & Commerce Integrations"
        }
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "Storefront & Headless Commerce Development"
        }
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "Order Management & ERP Integrations"
        }
      }
    ]
  }
}
        `}
                </script>

                {/* Service — Commerce Cloud (original service block) */}
                <script type="application/ld+json">
                    {`
{
  "@context": "https://schema.org",
  "@type": "Service",
  "@id": "https://www.codezix.com/salesforce/commerce-cloud#service",
  "url": "https://www.codezix.com/salesforce/commerce-cloud",
  "serviceType": "Salesforce Commerce Cloud Consulting & Implementation",
  "name": "Salesforce Commerce Cloud Consulting & Implementation",
  "description": "Commerce Cloud services by Codezix including storefront development, order management, merchandising, headless commerce, performance optimization and integrations with ERP/PO systems.",
  "provider": {
    "@type": "Organization",
    "@id": "https://codezix.com/#organization"
  },
  "areaServed": {
    "@type": "City",
    "name": "Global"
  },
  "hasOfferCatalog": {
    "@type": "OfferCatalog",
    "name": "Commerce Cloud Services",
    "itemListElement": [
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "Storefront Implementation & Theme Development"
        }
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "Order Management & OMS Integration"
        }
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "Headless Commerce & API Integrations"
        }
      }
    ]
  }
}
        `}
                </script>

                {/* ContactPoint */}
                <script type="application/ld+json">
                    {`
{
  "@context": "https://schema.org",
  "@type": "ContactPoint",
  "contactType": "customer support",
  "telephone": "+1-917-730-7436",
  "email": "info@codezix.com",
  "areaServed": ["US","UK","AE","DE","KW"],
  "availableLanguage": ["English"]
}
        `}
                </script>
            </Helmet>


            <div className="service-banner top bottom">
                <div className="container">
                    <div className='explore-heading'>
                        <h2>Salesforce Commerce Cloud</h2>
                    </div>
                    <div className="service-img mt-4">
                        <img src={require('../../assets/images/salesforce/Commerce-cloud.webp')} alt="" />
                    </div>
                </div>
            </div>

            <div className="container">
                <div className="row">
                    <div className="col-lg-3">
                        <ServiceInclude />
                    </div>

                    <div className="col-lg-9">

                        <div className="salesforce-service">
                            <div className='explore-service text-left'>
                                <p className="wow fadeUp prose-lg text-left">Codezix provides a complete suite of Salesforce Commerce Cloud solutions to elevate your online presence, enhance customer engagement, and drive sales growth.</p>
                            </div>
                        </div>

                        <div className="salesforce-services mt-4">
                            <div className='explore-heading text-left'>
                                <h2>Our B2B & B2C Salesforce Commerce Cloud Services</h2>
                            </div>

                            <div className='service-include-right mt-5'>
                                <div className='row'>
                                    <div className='col-lg-12 col-md-12 col-sm-9'>
                                        <div className='service-section-right'>
                                            <h3 className="wow fadeUp">Implementation & Customisation</h3>
                                            <p className="wow fadeUp prose-lg">Create an e-commerce solution tailored to your target market with
                                                {" "} <a
                                                    href="https://www.codezix.com/salesforce/development-company-in-kuwait"
                                                    className="text-blue-600 underline"
                                                    target="_blank"
                                                >
                                                    Salesforce Commerce Cloud.
                                                </a>{" "}

                                                Our developers customize B2B and B2C features to meet your specific business needs. Whether you're a wholesaler or distributor, we provide an exceptional shopping experience that resonates with your customers.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className='service-include-right mt-5'>
                                <div className='row'>
                                    <div className='col-lg-12 col-md-12 col-sm-9'>
                                        <div className='service-section-right'>
                                            <h3 className="wow fadeUp"> SFCC Consulting</h3>
                                            <p className="wow fadeUp prose-lg"> Ready to migrate to Salesforce Commerce Cloud or launch a store from scratch? Codezix has you covered! Our tailored solutions are designed to align with your business goals, ensuring long-term growth. Let our experts optimize your e-commerce platform, enhance the user experience, and drive sales success.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className='service-include-right mt-5'>
                                <div className='row'>
                                    <div className='col-lg-12 col-md-12 col-sm-9'>
                                        <div className='service-section-right'>
                                            <h3 className="wow fadeUp">SFCC Migration </h3>
                                            <p className="wow fadeUp prose-lg">Switch to Salesforce Commerce Cloud with ease and minimal downtime. Our experienced Salesforce experts manage data migration, code adjustments, and platform configuration, ensuring a smooth transition that keeps your business operations running without disruption. </p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className='service-include-right mt-5'>
                                <div className='row'>
                                    <div className='col-lg-12 col-md-12 col-sm-9'>
                                        <div className='service-section-right'>
                                            <h3 className="wow fadeUp"> SFCC Third-Party Integration</h3>
                                            <p className="wow fadeUp prose-lg">Expand your reach by selling across multiple digital channels. We simplify the integration of your commerce platform with Salesforce products and third-party systems, enabling seamless communication, improved operational efficiency, and enhanced collaboration. </p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className='service-include-right mt-5'>
                                <div className='row'>
                                    <div className='col-lg-12 col-md-12 col-sm-9'>
                                        <div className='service-section-right'>
                                            <h3 className="wow fadeUp">UI UX Design </h3>
                                            <p className="wow fadeUp prose-lg">Captivate your audience with visually stunning storefronts and intuitive interfaces. Our Commerce Cloud experts create impactful UI/UX designs that enhance user experiences, drive engagement, and increase conversions. With a focus on responsive design, we ensure seamless performance across both web and mobile platforms.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="salesforce-product">
                            <div className='explore-heading text-center'>
                                <h2>Industries We Serve</h2>
                            </div>

                            <div class="row mob-imagebox">
                                <div class="col-sm-4">
                                    <div class="blg">
                                        <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/salesforce/industry/healthcare.webp" alt="salesforce development services in Texas " />
                                        <div class="image-text">
                                            <p>Healthcare</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="blg">
                                        <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/salesforce/industry/retail.webp" alt="salesforce development company in Texas" />
                                        <div class="image-text">
                                            <p>E-Commerce</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="blg">
                                        <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/salesforce/industry/logistics.webp" alt="salesforce development company in Texas" />
                                        <div class="image-text">
                                            <p>Logistics</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="blg">
                                        <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/salesforce/industry/financial.webp" alt="salesforce development company in Texas" />
                                        <div class="image-text">
                                            <p>Financial</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="blg">
                                        <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/salesforce/industry/manufacturing.webp" alt="salesforce development company in Texas" />
                                        <div class="image-text">
                                            <p>Manufacturing</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="blg">
                                        <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/salesforce/industry/publicsector.webp" alt="salesforce development company in Texas" />
                                        <div class="image-text">
                                            <p>Public Sector</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="blg">
                                        <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/salesforce/industry/media.webp" alt="salesforce development company in Texas" />
                                        <div class="image-text">
                                            <p>Media</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="blg">
                                        <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/salesforce/industry/it.webp" alt="salesforce development company in Texas" />
                                        <div class="image-text">
                                            <p>IT Industry</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="blg">
                                        <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/salesforce/industry/telecom.webp" alt="salesforce development company in Texas" />
                                        <div class="image-text">
                                            <p>Telecom</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="blg">
                                        <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/salesforce/industry/education.webp" alt="salesforce development company in Texas" />
                                        <div class="image-text">
                                            <p>Education</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="salesforce-product">
                            <div className='explore-heading text-left'>
                                <h2>How can Salesforce Commerce Cloud can be beneficial for your business ?</h2>
                                <p className="prose-lg wow fadeUp text-left">Salesforce Commerce Cloud is an all-in-one platform that simplifies everything from launching digital storefronts to driving sales. Powered by Salesforce Einstein, it utilizes AI-driven automation and advanced tools to help brands create dynamic e-commerce sites while seamlessly integrating online and in-store experiences.</p>
                                <p className="prose-lg wow fadeUp text-left">Transform your customers' online shopping journey with the power of AI and real-time insights!</p>
                            </div>

                            <div className="row">
                                <div className="col-lg-6">
                                    <div className="why-listing mt-4">
                                        <ul>
                                            <li className="wow fadeUp prose-lg"> Increased Sales</li>
                                            <li className="wow fadeUp prose-lg"> Streamlined Operations</li>
                                            <li className="wow fadeUp prose-lg"> Data Driven Decisions</li>
                                        </ul>
                                    </div>
                                </div>
                                <div className="col-lg-6">
                                    <div className="why-listing mt-4">
                                        <ul>
                                            <li className="wow fadeUp prose-lg"> Improved Marketing</li>
                                            <li className="wow fadeUp prose-lg"> Stronger Brand Reputation</li>
                                            <li className="wow fadeUp prose-lg"> Global Commerce Capabilites</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="salesforce-product">
                            <div className='explore-heading text-left'>
                                <h2>Our Other Expertise in Salesforce Clouds</h2>
                                <p className="wow fadeUp prose-lg text-left">Deliver a tailored Salesforce experience that effortlessly aligns with your organization's goals and objectives.</p>
                            </div>
                            <div class="row mt-5">
                                <div class="col-sm-3">
                                    <div class="software-develop salesf-box height-100">
                                        <Link to="/salesforce/sales-cloud">
                                            <h3 class="mt-0">Sales Cloud</h3>
                                            <i class="fa fa-long-arrow-right arrow-icon" aria-hidden="true"></i>
                                        </Link>
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="software-develop salesf-box height-100">
                                        <Link to="/salesforce/service-cloud">
                                            <h3 class="mt-0">Service Cloud</h3>
                                            <i class="fa fa-long-arrow-right arrow-icon" aria-hidden="true"></i>
                                        </Link>
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="software-develop salesf-box height-100">
                                        <Link to="/salesforce/marketing-cloud">
                                            <h3 class="mt-0">Marketing Cloud</h3>
                                            <i class="fa fa-long-arrow-right arrow-icon" aria-hidden="true"></i>
                                        </Link>
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="software-develop salesf-box height-100">
                                        <Link to="/salesforce/community-cloud">
                                            <h3 class="mt-0">Community Cloud</h3>
                                            <i class="fa fa-long-arrow-right arrow-icon" aria-hidden="true"></i>
                                        </Link>
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="software-develop salesf-box height-100">
                                        <Link to="/salesforce/finencial-service-cloud">
                                            <h3 class="mt-0">Financial Services Cloud</h3>
                                            <i class="fa fa-long-arrow-right arrow-icon" aria-hidden="true"></i>
                                        </Link>
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="software-develop salesf-box height-100">
                                        <Link to="/salesforce/non-profit">
                                            <h3 class="mt-0">Nonprofit Cloud</h3>
                                            <i class="fa fa-long-arrow-right arrow-icon" aria-hidden="true"></i>
                                        </Link>
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="software-develop salesf-box height-100">
                                        <Link to="/salesforce/cpq">
                                            <h3 class="mt-0">Salesforce CPQ</h3>
                                            <i class="fa fa-long-arrow-right arrow-icon" aria-hidden="true"></i>
                                        </Link>
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="software-develop salesf-box height-100">
                                        <Link to="/salesforce/commercial-cloud#">
                                            <h3 class="mt-0">Salesforce Chatter</h3>
                                            <i class="fa fa-long-arrow-right arrow-icon" aria-hidden="true"></i>
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="salesforce-services mt-4">
                            <div className='explore-heading text-left'>
                                <h2>Customer Success Stories</h2>
                            </div>

                            <div className='service-include-right mt-5'>
                                <div className='row'>
                                    <div className='col-lg-2 col-md-2 col-sm-3'>
                                        <div className='service-section-left-img-york'>
                                            <img src={require('../../assets/images/salesforce/texes/storey-1.webp')} alt='' />
                                        </div>
                                    </div>
                                    <div className='col-lg-10 col-md-10 col-sm-9'>
                                        <div className='service-section-right'>
                                            <h3 className="wow fadeUp">
                                                3 PL Central</h3>
                                            <p className="wow fadeUp prose-lg"> That sounds very interesting! It seems like 3PL Central is offering a valuable solution for businesses looking to optimize their warehouse operations. A Warehouse Management System (WMS) can definitely help streamline processes, improve efficiency, and enhance customer satisfaction, which are key factors for business growth. Are you looking to integrate or improve Salesforce with their WMS, or do you need help with something else?</p>
                                            <Link to="/salesforce-consulting"><button>Learn More</button></Link>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className='service-include-right mt-5'>
                                <div className='row'>
                                    <div className='col-lg-2 col-md-2 col-sm-3'>
                                        <div className='service-section-left-img-york'>
                                            <img src={require('../../assets/images/salesforce/texes/storey-2.webp')} alt='' />
                                        </div>
                                    </div>
                                    <div className='col-lg-10 col-md-10 col-sm-9'>
                                        <div className='service-section-right'>
                                            <h3 className="wow fadeUp">24 Fit Club</h3>
                                            <p className="wow fadeUp prose-lg"> That sounds like a fantastic initiative by 24 Fit Club! Offering online classes is a great way to keep clients engaged, especially in today's digital age. By providing expert health and fitness advice, along with access to online classes, they can make fitness more accessible and help clients stay motivated, even from home. Is there something specific you're looking to explore or improve with 24 Fit Club's offerings, such as integrating Salesforce for better client management or enhancing their online experience?</p>
                                            <Link to="/salesforce-consulting"><button>Learn More</button></Link>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className='service-include-right mt-5'>
                                <div className='row'>
                                    <div className='col-lg-2 col-md-2 col-sm-3'>
                                        <div className='service-section-left-img-york'>
                                            <img src={require('../../assets/images/salesforce/texes/storey-3.webp')} alt='' />
                                        </div>
                                    </div>
                                    <div className='col-lg-10 col-md-10 col-sm-9'>
                                        <div className='service-section-right'>
                                            <h3 className="wow fadeUp"> Active Campaign</h3>
                                            <p className="wow fadeUp prose-lg"> Salesforce is one of the most powerful CRM solutions available today. As a leading enterprise-level customer relationship management application, it is compatible across multiple devices and boasts a robust app marketplace. Salesforce helps align your marketing and sales teams by delivering high-quality sales leads and enhancing pipeline management.

                                                Sounds intriguing?</p>
                                            <Link to="/salesforce-consulting"><button>Learn More</button></Link>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className='service-include-right mt-5'>
                                <div className='row'>
                                    <div className='col-lg-2 col-md-2 col-sm-3'>
                                        <div className='service-section-left-img-york'>
                                            <img src={require('../../assets/images/salesforce/texes/storey-4.webp')} alt='' />
                                        </div>
                                    </div>
                                    <div className='col-lg-10 col-md-10 col-sm-9'>
                                        <div className='service-section-right'>
                                            <h3 className="wow fadeUp">
                                                Advologix</h3>
                                            <p className="wow fadeUp prose-lg"> Headquartered in Sugar Land, Texas, Advologix is a digital consultancy specializing in legal document and case matter processing for law firms, legal departments, and public service organizations. The company designs centralized information management systems tailored for legal institutions. Its primary focus is to streamline case processing from start to resolution, improving efficiency and ensuring smoother workflows for its clients in the legal sector.</p>
                                            <Link to="/salesforce-consulting"><button>Learn More</button></Link>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className='service-include-right mt-5'>
                                <div className='row'>
                                    <div className='col-lg-2 col-md-2 col-sm-3'>
                                        <div className='service-section-left-img-york'>
                                            <img src={require('../../assets/images/salesforce/texes/storey-5.webp')} alt='' />
                                        </div>
                                    </div>
                                    <div className='col-lg-10 col-md-10 col-sm-9'>
                                        <div className='service-section-right'>
                                            <h3 className="wow fadeUp">
                                                Concert Health</h3>
                                            <p className="wow fadeUp prose-lg"> Concert Health assists physician practices in delivering integrated behavioral health services to their patients. This includes care management, brief therapy interventions, and psychiatric consultations. They provide specialized clinicians such as therapists and psychiatrists, along with the expertise and technology needed to enhance patient care and outcomes.</p>
                                            <Link to="/salesforce-consulting"><button>Learn More</button></Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className='service-include-right mt-5'>
                                <div className='row'>
                                    <div className='col-lg-2 col-md-2 col-sm-3'>
                                        <div className='service-section-left-img-york'>
                                            <img src={require('../../assets/images/salesforce/texes/storey-6.webp')} alt='' />
                                        </div>
                                    </div>
                                    <div className='col-lg-10 col-md-10 col-sm-9'>
                                        <div className='service-section-right'>
                                            <h3 className="wow fadeUp">
                                                At Home Solution</h3>
                                            <p className="wow fadeUp prose-lg">Based in New York, our client At Home Solutions offers personalized healthcare services designed to improve the quality of life for individuals of all ages. With over a decade of experience, AHS delivers effective and affordable care across the state. They provide the perfect blend of companionship, services, and support to ensure clients enjoy the highest quality of life.</p>
                                            <Link to="/salesforce-consulting"><button>Learn More</button></Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="salesforce-services mt-4">
                            <div className='explore-heading text-left'>
                                <h2>Want to explore more case studies</h2>
                                <p className="prose-lg text-left">Explore our detailed case studies of Salesforce here    .</p>
                            </div>

                            <div className='explore-heading text-left'>
                                <h2>Catch our trending blogs</h2>
                            </div>

                            <div className='service-include-right mt-5'>
                                <div className='row'>
                                    <div className='col-lg-2 col-md-2 col-sm-3'>
                                        <div className='service-section-left-img-york'>
                                            <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/salesforce/blog/commerce.webp" alt='' />
                                        </div>
                                    </div>
                                    <div className='col-lg-10 col-md-10 col-sm-9'>
                                        <div className='service-section-right'>
                                            <p className="prose-lg"><strong>Salesforce Commerce Cloud: Everything You Need to Know About</strong></p>
                                            <p className="wow fadeUp prose-lg"> In today’s fast-paced digital landscape, e-commerce has become a cornerstone of business success, driving fierce competition as companies strive to meet the growing demand for online shopping. With consumers increasingly relying on digital platforms for their purchasing needs, businesses must adapt quickly to stay ahead in this dynamic market.</p>
                                            <Link to="/salesforce-consulting"><button>Learn More</button></Link>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className='service-include-right mt-5'>
                                <div className='row'>
                                    <div className='col-lg-2 col-md-2 col-sm-3'>
                                        <div className='service-section-left-img-york'>
                                            <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/salesforce/blog/agent.webp" alt='' />
                                        </div>
                                    </div>
                                    <div className='col-lg-10 col-md-10 col-sm-9'>
                                        <div className='service-section-right'>
                                            <h3 className="wow fadeUp"><strong>Ultimate Guide to Salesforce Agentforce</strong></h3>
                                            <p className="wow fadeUp prose-lg"> The new hype in 2024 is Salesforce Agentforce. On Day Three of Dreamforce 2024, the third wave of AI was introduced with the launch of Agentforce. This innovation empowers employees by providing them with the tools and intelligence to enhance productivity, streamline workflows, and deliver superior customer experiences. </p>
                                            <Link to="/salesforce-consulting"><button>Learn More</button></Link>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className='service-include-right mt-5'>
                                <div className='row'>
                                    <div className='col-lg-2 col-md-2 col-sm-3'>
                                        <div className='service-section-left-img-york'>
                                            <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/salesforce/blog/marketing.webp" alt='' />
                                        </div>
                                    </div>
                                    <div className='col-lg-10 col-md-10 col-sm-9'>
                                        <div className='service-section-right'>
                                            <h3 className="wow fadeUp"><strong> What is Salesforce MuleSoft and How Codezix Can Help in Implementation and Customization of MuleSoft</strong> </h3>
                                            <p className="wow fadeUp prose-lg">
                                                In today’s fast-paced digital world, businesses are leveraging multiple applications, platforms, and services to streamline operations and improve customer experiences. However, connecting all these systems seamlessly is often a significant challenge. That’s where Salesforce Mulesoft....
                                            </p>
                                            <Link to="/salesforce-consulting"><button>Learn More</button></Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>


                    </div>
                </div>
            </div >
        </>
    )
}

export default CommercialCloud;